var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"multipleButtons"},[_c('div',{staticClass:"more"},_vm._l((_vm.filteredButtons),function(item,index){return _c('el-button',{key:index,class:item.class,attrs:{"type":item.type,"icon":item.icon},on:{"click":item.click}},[_vm._v(" "+_vm._s(item.name)+" ")])}),1),_c('div',{staticClass:"Refresh"})])
}
var staticRenderFns = []

export { render, staticRenderFns }